import { Route, Routes, useNavigate } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout';
import ProductNav from './shared/ProductNav';
import SettingsNav from './shared/SettingsNav';
import { useAuth } from '../hooks/auth/useAuth';
import DashboardPage from '../pages/admin/DashboardPage';
import PaymentNav from './shared/PaymentNav';
import OrderNav from './shared/OrderNav';

export default function AdminNav() {
    const navigate = useNavigate()
    const { logout, user } = useAuth()
    const goToProfile = () => {
        navigate("/admin/settings")
    }

    console.log("userrrrr", user)
    return (
        <AdminLayout
            onLogout={logout}
            onGotoProfile={goToProfile}
            companyName={user?.username || "Authentik Hair"}
            email={user?.email || 'admin.authentikhair.com'}
        >
            <Routes>
                <Route path="/products/*" element={<ProductNav />} />
                <Route path="/payments/*" element={<PaymentNav />} />
                <Route path="/orders/*" element={<OrderNav />} />
                <Route path="/settings/*" element={<SettingsNav />} />
                <Route path="/overview" element={<DashboardPage />} />

            </Routes>
        </AdminLayout>
    );
}